import React from "react";
//#region types
import { DrillDownTableRowSwitchProps } from "models/propTypes/simpleTableProps";
import { RowDisplayType } from "models/enums/table";
//#endregion
//#region components
import DrillDownTableEmptyRow from "./emptyRow";
import DrillDownTableBaseRow from "./baseRow";
import DrillDownTableDimensionRow from "./dimensionRow";
import DrillDownTableSumRow from "./sumRow";
import DrillDownTableSumSmallRow from "./sumSmallRow";
import DrillDownTableDimensionTitleRow from "./dimensionTitleRow";
//#endregion

const DrillDownTableRowTypeSwitch: React.FC<DrillDownTableRowSwitchProps> = ({ displayType, ...baseProps }) => {
  const { row, rowTextProperty } = baseProps;

  switch (displayType) {
    case RowDisplayType.Empty:
      return <DrillDownTableEmptyRow {...baseProps} showTotal={!!baseProps.showTotal} />;
    case RowDisplayType.Title:
      return (
        <DrillDownTableEmptyRow
          {...baseProps}
          text={row[rowTextProperty.key.toString()]}
          showTotal={!!baseProps.showTotal}
        />
      );
    case RowDisplayType.Sum:
      return <DrillDownTableSumRow {...baseProps} inlineExpansion />;
    case RowDisplayType.SumSmall:
      return <DrillDownTableSumSmallRow {...baseProps} inlineExpansion />;
    case RowDisplayType.DimensionTitle:
      return <DrillDownTableDimensionTitleRow {...baseProps} inlineExpansion />;
    case RowDisplayType.Dimension:
      return <DrillDownTableDimensionRow {...baseProps} />;
    default:
      return <DrillDownTableBaseRow {...baseProps} />;
  }
};

export default DrillDownTableRowTypeSwitch;
